(function(){
  var roots=document.querySelectorAll('[data-rr-root]');
  roots.forEach(function(root){
    if(root.dataset.ready==='true')return;
    root.dataset.ready='true';
    var q=function(s){return root.querySelector(s)};
    var qa=function(s){return Array.prototype.slice.call(root.querySelectorAll(s))};
    var track=function(name,data){window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name,product:'tesla_model_3_y_roof_rack'},data||{}))};
    var stage=q('[data-gallery-main]');
    qa('[data-gallery-thumb]').forEach(function(button){
      button.addEventListener('click',function(){
        var image=button.querySelector('img');
        if(stage&&image){stage.src=button.dataset.full||image.src;stage.alt=button.dataset.alt||image.alt;}
        qa('[data-gallery-thumb]').forEach(function(item){item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',item===button?'true':'false')});
        track('roof_rack_gallery_view',{position:Number(button.dataset.index||0)});
      });
    });
    var form=q('[data-product-form]');
    var radios=qa('[data-variant-radio]');
    var add=q('[data-add-button]');
    var addLabel=q('[data-add-label]');
    var fitMessage=q('[data-fit-message]');
    var status=q('[data-form-status]');
    var mobileLabel=q('[data-mobile-label]');
    var mobileAction=q('[data-mobile-action]');
    var selectedRadio=function(){return radios.find(function(r){return r.checked})};
    var syncVariant=function(radio,source){
      if(!radio)return;
      radios.forEach(function(r){r.checked=r===radio});
      qa('[data-fit-card]').forEach(function(card){card.classList.toggle('is-selected',card.dataset.variantId===radio.value)});
      if(add){add.disabled=!radio.checked||radio.disabled;}
      if(fitMessage){fitMessage.textContent='Fit confirmed: '+radio.dataset.title;fitMessage.classList.add('is-ready');}
      var fitLabel=radio.dataset.fitLabel||radio.dataset.title;
      var price=q('[data-price]')?.textContent?.trim()||'';
      var dynamicLabel='Add '+fitLabel+' rack — '+price;
      if(addLabel)addLabel.textContent=dynamicLabel;
      if(add)add.dataset.currentLabel=dynamicLabel;
      if(mobileLabel)mobileLabel.textContent=fitLabel+' · '+price;
      if(mobileAction)mobileAction.textContent='Add to cart';
      try{var url=new URL(window.location.href);url.searchParams.set('variant',radio.value);window.history.replaceState({},'',url.toString())}catch(e){}
      track('roof_rack_fitment_select',{variant_id:radio.value,fitment:radio.dataset.title,source:source||'buy_box'});
    };
    radios.forEach(function(radio){radio.addEventListener('change',function(){syncVariant(radio,'buy_box')})});
    qa('[data-fit-card]').forEach(function(card){card.addEventListener('click',function(){
      var radio=radios.find(function(r){return r.value===card.dataset.variantId});
      if(radio&&!radio.disabled){syncVariant(radio,'fitment_guide');q('[data-buy-box]')?.scrollIntoView({behavior:'smooth',block:'center'})}
    })});
    var initialId=new URLSearchParams(window.location.search).get('variant');
    var initial=radios.find(function(r){return r.value===initialId});
    if(initial)syncVariant(initial,'url');
    if(form){form.addEventListener('submit',function(event){
      event.preventDefault();
      var selected=selectedRadio();
      if(!selected){if(fitMessage){fitMessage.textContent='Please choose your Tesla model and model year first.';fitMessage.classList.remove('is-ready')}q('[data-variant-radio]')?.focus();return;}
      var original=add?.dataset.currentLabel||addLabel?.textContent||'Add to cart';
      if(add)add.disabled=true;if(addLabel)addLabel.textContent='Adding…';if(status)status.hidden=true;
      fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)})
        .then(function(response){if(!response.ok)return response.json().then(function(body){throw new Error(body.description||'Unable to add this item.')});return response.json()})
        .then(function(item){
          if(addLabel)addLabel.textContent='Added to cart';
          if(status){status.hidden=false;status.innerHTML='Added successfully. <a href="'+(window.routes&&window.routes.cart_url||'/cart')+'">View cart →</a>';}
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true}));
          track('roof_rack_add_to_cart',{variant_id:item.variant_id,quantity:item.quantity,fitment:selected.dataset.title});
          setTimeout(function(){if(addLabel)addLabel.textContent=original;if(add)add.disabled=false},2400);
        }).catch(function(error){if(status){status.hidden=false;status.textContent=error.message;}if(addLabel)addLabel.textContent=original;if(add)add.disabled=false});
    })}
    var mobile=q('[data-mobile-bar]');
    if(mobile&&add&&'IntersectionObserver'in window){new IntersectionObserver(function(entries){mobile.classList.toggle('is-visible',!entries[0].isIntersecting)},{threshold:.2}).observe(add)}
    q('[data-mobile-action]')?.addEventListener('click',function(){var selected=selectedRadio();if(selected&&form){form.requestSubmit()}else{q('[data-buy-box]')?.scrollIntoView({behavior:'smooth',block:'center'})}});
    qa('a[href^="#"]').forEach(function(link){link.addEventListener('click',function(){track('roof_rack_anchor_click',{destination:link.getAttribute('href')})})});
    qa('details').forEach(function(detail){detail.addEventListener('toggle',function(){if(detail.open)track('roof_rack_faq_open',{question:detail.querySelector('summary')?.innerText||''})})});
    if('IntersectionObserver'in window){var reveal=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');reveal.unobserve(entry.target)}})},{threshold:.12});qa('.rr-reveal').forEach(function(el){reveal.observe(el)})}else{qa('.rr-reveal').forEach(function(el){el.classList.add('is-visible')})}
  });
})();
